'use client'

import { useContext } from 'react'
import { Spacer } from '@vinted/web-ui'

import {
  ItemPagePricingPlugin,
  ItemPageShippingPricePlugin,
} from '@marketplace-web/escrow-pricing/escrow-pricing-feature'
import { PluginName, PluginsContext } from '@marketplace-web/item-page/item-page-data'
import {
  ItemPageBuyButtonPlugin,
  ItemPageMarkAsReservedButtonPlugin,
  ItemPageMarkAsSoldButtonPlugin,
} from '@marketplace-web/item-seller-action-buttons/item-action-buttons-feature'
import { ItemPageMakeOfferActionPlugin } from '@marketplace-web/offers/price-offers-feature'
import { ItemPageClosetCountdownActionPlugin } from '@marketplace-web/marketing-campaigns/closet-countdown-feature'
import { ItemPageAskSellerActionPlugin } from '@marketplace-web/messaging/conversation-messaging-feature'
import { ItemPageBumpActionPlugin } from '@marketplace-web/vas/vas-feature'
import {
  ItemPageDeleteActionPlugin,
  ItemPageEditActionPlugin,
  ItemPageHideActionPlugin,
} from '@marketplace-web/item-upload/listing-feature'

import Plugin from '../../plugins/Plugin'
import { SidebarSectionPlugins } from '../../utils/getSidebarSectionPlugins'

type Props = {
  plugins: SidebarSectionPlugins | null
}

const DetailsSection = ({ plugins }: Props) => {
  const { plugins: bedaPlugins } = useContext(PluginsContext)

  return (
    <>
      <div className="details-list details-list--main-info">
        <Plugin data={bedaPlugins?.find(plugin => plugin.name === PluginName.Summary)} />
        {plugins?.pricing && <ItemPagePricingPlugin data={plugins.pricing} />}
        <Plugin data={bedaPlugins?.find(plugin => plugin.name === PluginName.Klarna)} />
        <Plugin data={bedaPlugins?.find(plugin => plugin.name === PluginName.HighDemandSignal)} />
        <Plugin data={bedaPlugins?.find(plugin => plugin.name === PluginName.Attributes)} />
      </div>
      <div className="details-list__info">
        <Plugin data={bedaPlugins?.find(plugin => plugin.name === PluginName.Description)} />
        {plugins?.shippingPrice && <ItemPageShippingPricePlugin data={plugins.shippingPrice} />}
        <Spacer size={Spacer.Size.Large} />
        <div className="details-list__item details-list--actions">
          <div className="u-grid u-gap-regular">
            {plugins?.buyButton && <ItemPageBuyButtonPlugin data={plugins.buyButton} />}
            {plugins?.makeOfferAction && (
              <ItemPageMakeOfferActionPlugin data={plugins.makeOfferAction} />
            )}
            {plugins?.closetCountdownAction && (
              <ItemPageClosetCountdownActionPlugin data={plugins.closetCountdownAction} />
            )}
            {plugins?.askSellerAction && (
              <ItemPageAskSellerActionPlugin data={plugins.askSellerAction} />
            )}
            <ItemPageBumpActionPlugin bumpActionPluginModel={plugins?.bumpAction ?? undefined} />
            <ItemPageMarkAsSoldButtonPlugin data={plugins?.markAsSoldButton ?? undefined} />
            <ItemPageMarkAsReservedButtonPlugin data={plugins?.markAsReservedButton ?? undefined} />
            <ItemPageHideActionPlugin hideActionPluginModel={plugins?.hideAction ?? undefined} />
            <ItemPageEditActionPlugin editActionPluginModel={plugins?.editAction ?? undefined} />
            <ItemPageDeleteActionPlugin
              deleteActionPluginModel={plugins?.deleteAction ?? undefined}
            />
          </div>
          <Spacer />
        </div>
      </div>
    </>
  )
}

export default DetailsSection
